<div class="flex w-100 h-100 justify-content-center align-items-center">
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="96.742px"
    height="28.641px"
    viewBox="0 0 96.742 28.641"
    enable-background="new 0 0 96.742 28.641"
    xml:space="preserve"
  >
    <g>
      <g>
        <path
          d="M61.748,6.267h3.54v11.035c0,0.983,0.442,1.42,1.438,1.42h5.311c0.996,0,1.438-0.437,1.438-1.42V6.267h3.54v11.909
                c0,2.185-1.438,3.605-3.651,3.605h-7.966c-2.213,0-3.651-1.42-3.651-3.605V6.267z"
        />
        <path
          d="M56.536,6h-3.829H44v16h13v-3H47v-4h7v-3h-7V9h5.707h2.533c0.016,0,0.032,0,0.048,0h0.299h0.048h0.409h0.347
                C56.685,9,57,9.039,57,8.744v-0.6c0-0.022,0-0.043,0-0.064V6H56.536z"
        />
        <path
          d="M92.495,13.02l-6.237-0.996C85.373,11.891,85,11.581,85,10.807v-0.221C85,9.7,85.339,9,86.224,9h7.366h0.484
                c0.016,0,0.032,0,0.048,0h0.216h0.048h0.492h0.263C95.436,9,95,9.038,95,8.743V8.74V8.144v-0.03V8.081c0-0.022,0-0.043,0-0.064V6
                h-1.41h-8.472C82.905,6,81,7.709,81,9.922v1.66c0,1.881,1.45,3.076,3.663,3.43l6.158,0.996C91.706,16.14,92,16.449,92,17.224
                v0.221C92,18.33,91.977,19,91.092,19H81v3h11.199C94.411,22,96,20.322,96,18.109v-1.66C96,14.568,94.708,13.374,92.495,13.02z"
        />
        <path
          d="M39,9.21V6H24v2.115c0,0.01,0,0.02,0,0.03v0.599C24,9.038,24.799,9,25.094,9h0.756c0.016,0,0.032,0,0.048,0H33v0.653
                l-9,9.293V22h15v-3H29v-0.496L39,9.21z"
        />
      </g>
      <path
        fill="#0000FF"
        d="M4.831,18.122c-0.757,0.958-1.136,2.154-1.068,3.375l0.007,0.107c0.103,1.387,0.788,2.677,1.883,3.542
            l4.05,3.2l8.364-10.587c0.757-0.958,1.136-2.154,1.067-3.378l-0.007-0.105c-0.103-1.387-0.789-2.677-1.88-3.539l-2.328-1.772
            l-1.442,2.08l2.122,1.589l0.091,0.072c0.551,0.435,0.883,1.059,0.934,1.753l0.004,0.073c0.034,0.602-0.155,1.196-0.531,1.672
            L9.289,24.82l-2.081-1.644c-0.551-0.435-0.883-1.059-0.934-1.756L6.27,21.35c-0.028-0.491,0.093-0.976,0.342-1.397l5.462-6.914
            l-1.97-1.556L4.831,18.122z"
      />
      <linearGradient id="SVGID_1_" gradientUnits="userSpaceOnUse" x1="6.9811" y1="15.6762" x2="8.3961" y2="5.2056">
        <stop offset="0.1517" style="stop-color:#0000FF" />
        <stop offset="1" style="stop-color:#191553" />
      </linearGradient>
      <path
        fill="url(#SVGID_1_)"
        d="M14.311,10.224c0.757-0.958,1.136-2.154,1.068-3.375l-0.007-0.107
            c-0.103-1.387-0.788-2.677-1.883-3.542L9.44,0L1.075,10.587c-0.757,0.958-1.136,2.154-1.067,3.378l0.007,0.105
            c0.103,1.387,0.789,2.677,1.88,3.539l0.951,0.658l1.399-2.084l-0.702-0.471L3.453,15.64c-0.551-0.435-0.883-1.059-0.934-1.753
            l-0.004-0.073c-0.034-0.602,0.155-1.196,0.531-1.672l6.808-8.617l2.081,1.644c0.551,0.435,0.883,1.059,0.934,1.756l0.004,0.07
            c0.028,0.491-0.093,0.976-0.342,1.397l-5.462,6.914l3.201-0.002L14.311,10.224z"
      />
    </g>
  </svg>
</div>
